import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=7527924b&scoped=true"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"
import style0 from "./Side.vue?vue&type=style&index=0&id=7527924b&prod&scoped=true&lang=css"
import style1 from "./Side.vue?vue&type=style&index=1&id=7527924b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527924b",
  null
  
)

export default component.exports